// ============================================================================
// note-client-mod -- useResponsive Hook
//
// 响应式布局工具 Hook，监听视口尺寸并返回断点匹配信息。
// ============================================================================
import * as React from 'react';
import { breakpoints } from './theme.js';
function getResponsiveState() {
    if (typeof window === 'undefined') {
        return { width: 1024, height: 768, isMobile: false, isTablet: false, isDesktop: true, isWide: false, breakpoint: 'lg' };
    }
    const width = window.innerWidth;
    const height = window.innerHeight;
    const isMobile = width < breakpoints.md;
    const isTablet = width >= breakpoints.md && width < breakpoints.lg;
    const isDesktop = width >= breakpoints.lg;
    const isWide = width >= breakpoints.xl;
    let breakpoint;
    if (width < breakpoints.sm)
        breakpoint = 'xs';
    else if (width < breakpoints.md)
        breakpoint = 'sm';
    else if (width < breakpoints.lg)
        breakpoint = 'md';
    else if (width < breakpoints.xl)
        breakpoint = 'lg';
    else
        breakpoint = 'xl';
    return { width, height, isMobile, isTablet, isDesktop, isWide, breakpoint };
}
export function useResponsive() {
    const [state, setState] = React.useState(getResponsiveState);
    React.useEffect(() => {
        let rafId;
        const handleResize = () => {
            cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => setState(getResponsiveState()));
        };
        window.addEventListener('resize', handleResize, { passive: true });
        window.addEventListener('orientationchange', handleResize);
        return () => {
            cancelAnimationFrame(rafId);
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);
    return state;
}
//# sourceMappingURL=use-responsive.js.map